// Web app config reads from Vite env vars at build time.
// In dev: put them in web/.env.local (gitignored).
// In Cloudflare Pages: set them in the project's Environment Variables.
//
// Required:
//   VITE_SUPABASE_URL
//   VITE_SUPABASE_ANON_KEY
//   VITE_ANTHROPIC_API_KEY
//
// The Anthropic key is bundled client-side. This is the same tradeoff the
// bare-RN app makes (see src/lib/config.example.ts in the repo root). For a
// personal-use / invite-only web app it's acceptable.

function requireEnv(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(
      `Missing required env var ${name}. Add it to web/.env.local for dev or to Cloudflare Pages env vars for production.`
    );
  }
  return value;
}

export const config = {
  SUPABASE_URL: requireEnv("VITE_SUPABASE_URL"),
  SUPABASE_ANON_KEY: requireEnv("VITE_SUPABASE_ANON_KEY"),
  ANTHROPIC_API_KEY: requireEnv("VITE_ANTHROPIC_API_KEY"),
};
